import ImagesModel from "../../../Global/Models/Images/ImagesModel";
import RelatedEntityRelationship from "../../../Global/Models/Related/RelatedEntityRelationship";
import { GameStatusEnum } from "../../TopX/Enums/GameStatusEnum";
import BracketGameFixturesModel from "./BracketGameFixturesModel";
import BracketGameMetaModel from "./BracketGameMetaModel";
import BracketGameTiebreakerModel from "./BracketGameTiebreakerModel";

export default class BracketGameModel {
  public id: string = null;
  public title: string = null;
  public description: string | null = null;
  public rules: string | null = null;
  public customFields: Record<string, string> | null = null;
  public images: ImagesModel | null = null;
  public type: string = "BRACKET";
  public status: GameStatusEnum = null;
  public points: number = null;
  public related: RelatedEntityRelationship[] = [];
  public tiebreaker: BracketGameTiebreakerModel | null = null;
  public predictionsCutoff: string | null = null;
  public meta: BracketGameMetaModel = new BracketGameMetaModel();
  public fixtures: BracketGameFixturesModel[] = [];
  public createdAt: string = null;
  public updatedAt: string = null;
}
